import { useSelector } from 'react-redux'

import { getBasketDate, getChosenAddress, getNumPortions } from 'selectors/basket'

import type { OrderDetailsTrackingProperties } from './tracking'
import { DEFAULT_PORTION_SIZE } from './useDeliverySettings'

// Raw basket values for the click_order_details_dropdown payload (useDeliverySettings
// formats the same values for display). transaction_type is constant — transactional-only.
export const useOrderDetailsTrackingProperties = (): OrderDetailsTrackingProperties => {
  const numPortions = useSelector(getNumPortions)
  const basketDate = useSelector(getBasketDate)
  const chosenAddress = useSelector(getChosenAddress)

  return {
    delivery_date: basketDate ?? '',
    num_portions: numPortions ?? DEFAULT_PORTION_SIZE,
    postcode: chosenAddress?.get('postcode') ?? '',
    transaction_type: 'transactional',
  }
}
